import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import axios, { CancelTokenSource } from 'axios';
import UpsertPrescriptionModal from 'components/clinical-data/UpsertPrescriptionModal';
import {
  ConsultationsConsumerRenderProps,
  withConsultationsContext
} from 'components/consultations/ConsultationsContext';
import EditActionButton from 'components/EditActionButton';
import FormModalContentContainer from 'components/layout/FormModalContentContainer';
import HomeRightHeader from 'components/layout/HomeRightHeader';
import HomeTableHeaderCell from 'components/layout/HomeTableHeaderCell';
import PxGrid from 'components/layout/PxGrid';
import ToolbarButton from 'components/layout/ToolbarButton';
import { PatientConsumerRenderProps, withPatientContext } from 'components/patient/PatientContext';
import UpsertPhysiotherapyReportModal from 'components/patient/upsert/UpsertPhysiotherapyReportModal';
import UpsertSynopsisReportModal from 'components/patient/upsert/UpsertSynopsisReportModal';
import PdfModal from 'components/pdf-modal/PdfModal';
import UnableToWorkPdfModal from 'components/pdf-modal/UnableToWorkPdfModal';
import { TreatmentsConsumerRenderProps, withTreatmentsContext } from 'components/treatments/TreatmentsContext';
import { NotificationSystemProps, withNotificationSystemContext } from 'context/NotificationSysemContext';
import moment from 'moment';
import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from "react-message-source";
import { Button, Grid, Header, Icon, Modal, Popup, Segment, Table } from 'semantic-ui-react';
import { getPdfUrl } from 'services/documentServices';
import { getMedicamentsWithDosages } from 'services/medicamentServices';
import {
  getPhysiotherapyReport,
  getPrescription,
  getSynopsisReport
} from 'services/patientMedicalDocumentEditReportServices';
import { getCdrDocumentFiles, getPdfDocumentUrl } from 'services/patientRecordServices';
import {
  addPatientEmail,
  prescriptionDocument,
  sendUnableToWorkEmailToPatient,
  unableToWorkPatientDocument
} from 'services/patientServices';
import { getAllTreatmentsByPatientId } from 'services/treatmentServices';
import styled from 'styled-components';
import { BillStatus, PatientDocumentType, PatientReportStatus, Privilege } from 'ts-types/api.enums';
import {
  CdrDocumentFileContent,
  PatientDocumentRequest,
  PatientEmailFormDto,
  PatientEmailRequest,
  PatientPhysiotherapyReportDto,
  PatientSynopsisReportDto,
  PdfResponse,
  PrescriptionDocumentRequest,
  PrescriptionDto,
  PrescriptionMedicamentDto,
  TreatmentDocumentDto,
  TreatmentDto,
  UnableToWorkEmailRequest
} from 'ts-types/api.types';

const StyledTreatmentInformation = styled(Segment)`
  .ui.grid {
    margin-top: 0.2rem;
    margin-bottom: 0.175rem;
  }

  .ui.grid > .row {
    padding-top: 0.375rem;
    padding-bottom: 0.1rem;
  }

  .unable-to-work-header {
    .unable-to-work-action {
      float: right;
      margin-top: -0.5rem;
      margin-bottom: 1rem;
    }
  }

  .prescription-list {
    margin-top: 0.5rem;
    display: grid;
    grid-template-columns: min-content 1fr min-content;
    column-gap: 1rem;
    row-gap: 0.1rem;
    align-items: center;

    .header {
      font-weight: bold;
      font-size: 0.9rem;
      color: rgba(0, 0, 0, 0.8);
    }

    .actions .ui.button .icon.large {
      font-size: 1.275rem;
    }
  }

  .header-buttons {
    float: right;
  }
`;

const TitleColumn = styled(Grid.Column)`
  width: 10% !important;
  min-width: 8rem;
  flex-grow: 0;
  flex-shrink: 0;
`;

const InformationColumn = styled(Grid.Column)`
  flex-grow: 1;
`;

const StyledColumn = styled(Grid.Column)`
  &.no-padding-right {
    padding-left: 0 !important;
  }
`;

const TreatmentDocumentsContainer = styled.div`
  width: 100%;
  cursor: context-menu;
  overflow: auto;
  max-height: 321px;

  & .ui.table {
    margin-top: 0.2rem;
  }

  & .ui.table thead tr:first-child > th {
    position: sticky !important;
    top: 0;
    z-index: 2;
    background: #fff;
  }

  .date-class {
    display: inline-flex;
    padding-right: 5px;
  }

  .icon-class {
    display: inline-flex;
  }
`;

const btnStyle = {
  background: 'transparent',
  cursor: 'pointer',
  padding: '5px 5px'
};

interface Props
    extends AuthConsumerRenderProps,
        PatientConsumerRenderProps,
        TreatmentsConsumerRenderProps,
        ConsultationsConsumerRenderProps,
        NotificationSystemProps,
        MessageSourceProps {

  hoverMessage: string,
  onConfirm?: () => void
}

interface State {
  unableToWorkPdfModalOpen: boolean,
  unableToWorkPdfSendEmailInProgress: boolean,
  unableToWorkOutput: Array<PatientEmailFormDto>,

  prescriptionPdfModalOpen: boolean,
  prescriptionPdfSendEmailInProgress: boolean,
  prescriptionOutput: Array<PatientEmailFormDto>,

  synopsisReportPdfModalOpen: boolean,
  synopsisReportPdfResponse?: CdrDocumentFileContent[],

  physiotherapyReportPdfModalOpen: boolean,
  physiotherapyReportPdfResponse?: CdrDocumentFileContent[],

  synopsisModalOpen: boolean,
  physiotherapyModalOpen: boolean,

  prescriptionModalOpen: boolean,
  prescriptionDetails?: PrescriptionDto,

  reportId?: number,

  synopsisReportDetails?: PatientSynopsisReportDto,
  physiotherapyReportDetails?: PatientPhysiotherapyReportDto,

  prescriptionId: number,

  medicaments: Array<PrescriptionMedicamentDto>,

  documentId?: number,
  patientId?: number,
  showSetControlledButton: boolean,

  cancelTokenSource: CancelTokenSource
}

// const TreatmentInformation = (props: MessageSourceProps) => {
class TreatmentInformation extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      unableToWorkPdfModalOpen: false,
      unableToWorkPdfSendEmailInProgress: false,
      unableToWorkOutput: [],

      prescriptionPdfModalOpen: false,
      prescriptionPdfSendEmailInProgress: false,
      prescriptionOutput: [],

      synopsisReportPdfModalOpen: false,
      physiotherapyReportPdfModalOpen: false,

      synopsisModalOpen: false,
      physiotherapyModalOpen: false,
      prescriptionModalOpen: false,

      prescriptionId: -1,

      medicaments: [],

      showSetControlledButton: false,

      cancelTokenSource
    }

    getMedicamentsWithDosages(cancelTokenSource)
        .then(response => {
          this.setState({
            medicaments: response
          })
        });
  }

  refreshTreatment = async () => {
    const {currentPatient, selectedTreatment, changeSelectedTreatment} = this.props;
    const {cancelTokenSource} = this.state;

    const patientId = currentPatient!.id;
    const selectedTreatmentId = selectedTreatment!.id;

    const allTreatments = await getAllTreatmentsByPatientId(cancelTokenSource, patientId);
    const changedTreatment = allTreatments.find((treatment: TreatmentDto) => treatment.id === selectedTreatmentId);

    changeSelectedTreatment(changedTreatment);
  }

  openUnableToWorkPdf = async () => {
    const {cancelTokenSource} = this.state;
    const {selectedTreatment, currentUser, options} = this.props;

    const patientDocumentRequest: PatientDocumentRequest = {
      treatmentId: selectedTreatment!.id,
      treaterId: options.currentTreater!.id,
      mandateId: currentUser!.userConfig!.mandateId
    }

    const response: PatientEmailFormDto[] = await unableToWorkPatientDocument(patientDocumentRequest, cancelTokenSource);
    await this.openUnableToWorkPdfModal(response);
  }

  openUnableToWorkPdfModal = (unableToWorkPdfResponse: PatientEmailFormDto[]) => {
    this.setState({
      unableToWorkPdfModalOpen: true,
      unableToWorkOutput: unableToWorkPdfResponse
    })
  };

  closeUnableToWorkPdfModal = () => {

    this.setState({
      unableToWorkPdfModalOpen: false,
      unableToWorkOutput: []
    });
  };

  sendUnableToWorkEmail = async (emailRequest: UnableToWorkEmailRequest) => {
    const {cancelTokenSource} = this.state;

    this.setState({
      unableToWorkPdfSendEmailInProgress: true
    });

    try {
      await sendUnableToWorkEmailToPatient(emailRequest, cancelTokenSource);
    } finally {
      this.setState({
        unableToWorkPdfSendEmailInProgress: false
      });
    }

    this.closeUnableToWorkPdfModal();
  }

  openEditDocumentModal = (document: TreatmentDocumentDto) => {
    const {cancelTokenSource} = this.state;

    if (PatientDocumentType.PRESCRIPTION == document.type) {
      this.openPrescriptionModal(document);
    } else if (PatientDocumentType.PATIENT_SYNOPSIS_REPORT == document.type) {
      getSynopsisReport(document.reportId, cancelTokenSource)
          .then(response => {
            this.setState({
              synopsisReportDetails: response,
              reportId: document.reportId,
              synopsisModalOpen: true
            });
          });
    } else {
      getPhysiotherapyReport(document.reportId, cancelTokenSource)
          .then(response => {
            this.setState({
              physiotherapyReportDetails: response,
              reportId: document.reportId,
              physiotherapyModalOpen: true
            })
          });
    }
  }

  openDocumentPdf = (document: TreatmentDocumentDto) => {
    const type = document.type;
    const documentId = document.documentId;

    if (PatientDocumentType.PRESCRIPTION == type) {
      this.openPrescriptionPdf(documentId);
    } else if (PatientDocumentType.PATIENT_SYNOPSIS_REPORT == type) {
      this.setState({
        showSetControlledButton: document.reportStatus === null
            || PatientReportStatus.PREPARED === document.reportStatus
      })
      this.openSynopsisReportPdf(documentId);
    } else if (PatientDocumentType.PATIENT_PHYSIOTHERAPY_REPORT == type) {
      this.openPhysiotherapyReportPdf(documentId);
    }
  }

  openPrescriptionPdf = async (prescriptionId: number) => {
    const {cancelTokenSource} = this.state;
    const {selectedTreatment, currentUser, options} = this.props;

    this.setState({
      prescriptionId
    });

    const prescriptionDocumentRequest: PrescriptionDocumentRequest = {
      prescriptionId: prescriptionId,
      treatmentId: selectedTreatment!.id,
      treaterId: options.currentTreater!.id,
      mandateId: currentUser!.userConfig!.mandateId
    }

    const response: PatientEmailFormDto[] = await prescriptionDocument(prescriptionDocumentRequest, cancelTokenSource);
    await this.openPrescriptionPdfModal(response);
  }

  openPrescriptionPdfModal = (prescriptionPdfResponse: PatientEmailFormDto[]) => {
    this.setState({
      prescriptionPdfModalOpen: true,
      prescriptionOutput: prescriptionPdfResponse
    })
  };

  closePrescriptionPdfModal = () => {

    this.setState({
      prescriptionPdfModalOpen: false,
      prescriptionOutput: []
    });
  };

  openSynopsisReportPdf = async (documentId: number) => {
    const {currentPatient} = this.props;
    const {cancelTokenSource} = this.state;

    const patientId = currentPatient!.id;

    this.setState({
      patientId: patientId,
      documentId: documentId
    })

    const response: CdrDocumentFileContent[] =
        await getCdrDocumentFiles(patientId, documentId, cancelTokenSource);
    await this.openSynopsisPdfModal(response);
  }

  openSynopsisPdfModal = (response: CdrDocumentFileContent[]) => {
    this.setState({
      synopsisReportPdfModalOpen: true,
      synopsisReportPdfResponse: response
    })
  };

  closeSynopsisPdfModal = () => {

    this.setState({
      synopsisReportPdfModalOpen: false,
      synopsisReportPdfResponse: undefined
    });
  };

  openPhysiotherapyReportPdf = async (documentId: number) => {
    const {currentPatient} = this.props;
    const {cancelTokenSource} = this.state;

    const patientId = currentPatient!.id;

    const response: CdrDocumentFileContent[] =
        await getCdrDocumentFiles(patientId, documentId, cancelTokenSource);
    await this.openPhysiotherapyPdfModal(response);
  }

  openPhysiotherapyPdfModal = (response: CdrDocumentFileContent[]) => {
    this.setState({
      physiotherapyReportPdfModalOpen: true,
      physiotherapyReportPdfResponse: response
    })
  };

  closePhysiotherapyPdfModal = () => {

    this.setState({
      physiotherapyReportPdfModalOpen: false,
      physiotherapyReportPdfResponse: undefined
    });
  };

  openPrescriptionModal = (document?: TreatmentDocumentDto) => {
    const {cancelTokenSource} = this.state;

    if (document) {
      if (PatientDocumentType.PRESCRIPTION == document.type) {
        getPrescription(document.documentId, cancelTokenSource)
            .then(response => {
              this.setState({
                prescriptionDetails: response,
                prescriptionModalOpen: true
              });
            })
      }
    } else {
      this.setState({
        prescriptionModalOpen: true
      })
    }
  }

  closePrescriptionModal = () => {
    this.setState({
      prescriptionDetails: undefined,
      prescriptionModalOpen: false
    })
  }

  savePrescriptionModal = () => {
    this.closePrescriptionModal();
    this.refreshTreatment();
  }

  openSynopsisModal = () => {
    this.setState({
      synopsisModalOpen: true
    })
  }

  closeSynopsisModal = (savedDocument: boolean) => {
    this.setState({
      synopsisReportDetails: undefined,
      reportId: undefined,
      synopsisModalOpen: false
    });

    if (savedDocument) {
      this.refreshTreatment();
    }
  }

  openPhysiotherapyModal = () => {
    this.setState({
      physiotherapyModalOpen: true
    })
  }

  closePhysiotherapyModal = (savedDocument: boolean) => {
    this.setState({
      physiotherapyReportDetails: undefined,
      reportId: undefined,
      physiotherapyModalOpen: false
    })

    if (savedDocument) {
      this.refreshTreatment();
    }
  }

  getPatientDocumentPdfUrl = (pdfResponse: PdfResponse) => {
    return getPdfDocumentUrl(pdfResponse.pdfId, pdfResponse.pdfName);
  }

  savePatientEmail = async (emailRequest: UnableToWorkEmailRequest) => {

    const {prescriptionId, cancelTokenSource} = this.state;
    const {
      selectedTreatment,
      changeSelectedTreatment,
      currentUser,
      options
    } = this.props;

    this.setState({
      prescriptionPdfSendEmailInProgress: true
    });

    const request: PatientEmailRequest = {
      mandateId: currentUser!.userConfig!.mandateId,
      documentId: prescriptionId,
      documentType: PatientDocumentType.PRESCRIPTION,
      treatmentId: selectedTreatment!.id,
      treaterId: options.currentTreater!.id,
      emailsTo: emailRequest.emailsTo,
      emailsCc: emailRequest.emailsCc,
      subject: emailRequest.subject,
      messageText: emailRequest.messageText
    }

    try {
      await addPatientEmail(request, cancelTokenSource);
    } finally {
      this.setState({
        prescriptionPdfSendEmailInProgress: false
      });
    }

    this.closePrescriptionPdfModal();

    changeSelectedTreatment(selectedTreatment);
  }

  successfullyChangedReportStatus = () => {
    const {selectionNotificationSystem, getMessage} = this.props;

    //@ts-ignore
    const notification = selectionNotificationSystem.current;
    if (notification) {

      notification.addNotification({
        title: getMessage("patientRecord.patientDocument.successfullySetControlledStatus.title"),
        message: getMessage("patientRecord.patientDocument.successfullySetControlledStatus"),
        level: 'success'
      });
    }
  }

  renderPrescriptionForm = (): React.ReactNode => {

    const {currentPatient, selectedTreatment, getMessage, options} = this.props;
    const {prescriptionModalOpen, medicaments, prescriptionDetails} = this.state;

    const currentTreaterId = options.currentTreater!.id;

    let prescription: Partial<PrescriptionDto> = {
      prescriptionDate: moment().format("YYYY-MM-DD"),
      medicaments: []
    }

    if (prescriptionDetails) {
      prescription = {
        ...prescriptionDetails
      }
    }

    return (
        <Modal
            size="large"
            open={prescriptionModalOpen}
            onClose={() => this.closePrescriptionModal}
            closeOnDimmerClick={false}
        >
          <Modal.Header>{getMessage('prescription.title')}</Modal.Header>
          <FormModalContentContainer>
            <UpsertPrescriptionModal
                patientId={currentPatient!.id}
                currentTreaterId={currentTreaterId}
                prescription={prescription}
                medicaments={medicaments}
                onCloseEditPrescription={this.closePrescriptionModal}
                onSaveEditPrescription={this.savePrescriptionModal}
                treatmentId={selectedTreatment!.id}
            />
          </FormModalContentContainer>
        </Modal>
    );
  }

  renderEditSynopsisReport = (): React.ReactNode => {
    const {
      synopsisReportDetails,
      synopsisModalOpen,
      reportId
    } = this.state;

    const {
      currentPatient,
      selectedTreatment
    } = this.props;

    return (
        <UpsertSynopsisReportModal
            modalOpen={synopsisModalOpen}
            onCloseModal={this.closeSynopsisModal}
            patient={currentPatient}
            treatmentId={selectedTreatment!.id}
            reportDetails={synopsisReportDetails}
            documentId={reportId}
        />
    )
  }

  renderEditPhysiotherapyReport = (): React.ReactNode => {
    const {
      physiotherapyModalOpen,
      physiotherapyReportDetails,
      reportId
    } = this.state;

    const {
      currentPatient,
      selectedTreatment
    } = this.props;

    return (
        <UpsertPhysiotherapyReportModal
            modalOpen={physiotherapyModalOpen}
            onCloseModal={this.closePhysiotherapyModal}
            patient={currentPatient}
            treatmentId={selectedTreatment!.id}
            reportDetails={physiotherapyReportDetails}
            documentId={reportId}
        />
    )
  }

  render() {
    const {
      currentPatient,
      selectedTreatment,
      selectedConsultation,
      getMessage,
      language,
      currentUserHasPrivilege,
      currentUser
    } = this.props;

    const {
      unableToWorkPdfModalOpen,
      unableToWorkPdfSendEmailInProgress,
      unableToWorkOutput,
      prescriptionPdfModalOpen,
      prescriptionPdfSendEmailInProgress,
      synopsisReportPdfModalOpen,
      synopsisReportPdfResponse,
      physiotherapyReportPdfModalOpen,
      physiotherapyReportPdfResponse,
      prescriptionOutput,
      synopsisModalOpen,
      physiotherapyModalOpen,
      prescriptionModalOpen,
      showSetControlledButton,
      patientId,
      documentId
    } = this.state;

    const mandate = selectedTreatment != undefined ? selectedTreatment.mandate : "";
    const treater = selectedConsultation != undefined ? selectedConsultation.treater : "";
    const reason = selectedTreatment != undefined ? selectedTreatment.reason : "";
    const guarantor = selectedTreatment != undefined ? selectedTreatment.guarantor : "";
    const bookingData = selectedTreatment != undefined ? selectedTreatment.treatmentData : undefined;

    const hasUnfitSection = selectedTreatment != undefined
        && selectedTreatment.unfit != null && selectedTreatment.unfit.length;

    const hasDocumentsSection = selectedTreatment != undefined && selectedTreatment.treatmentDocuments != null &&
        selectedTreatment.treatmentDocuments.length;


    const hasUnfitOrPrescriptionPrivilege =
        currentUserHasPrivilege(Privilege.PX_CORE_UNABLE_TO_WORK_OR_PRESCRIPTION_REPORT);

    let interventionDescription = "";
    let productCode = "";
    if (bookingData && bookingData.intervention) {
      if (language === 'en' && bookingData.intervention.descriptionEn !== null) {
        interventionDescription = bookingData.intervention.descriptionEn;
      } else if (language === 'fr' && bookingData.intervention.descriptionFr !== null) {
        interventionDescription = bookingData.intervention.descriptionFr;
      } else if (language === 'it' && bookingData.intervention.descriptionIt !== null) {
        interventionDescription = bookingData.intervention.descriptionIt;
      } else {
        interventionDescription = bookingData.intervention.description;
      }
    }

    if (bookingData && bookingData.product) {
      productCode = "(" + bookingData.product.id + ")";
    }

    const documents = (selectedTreatment !== undefined && selectedTreatment.treatmentDocuments !== null)
        ? selectedTreatment.treatmentDocuments
        : [];

    const shouldHideButtons = !currentPatient
        || !selectedTreatment
        || (BillStatus.OPEN != selectedTreatment.billStatus)
        || (currentUser
            && currentUser.userConfig.mandateId !== selectedTreatment.mandateId);

    return (
        <StyledTreatmentInformation>
          <PxGrid>
            <Grid.Row>
              <Grid.Column className="no-padding-right" style={{paddingLeft: 0, paddingRight: 0}} width={8}>
                <HomeRightHeader>{getMessage('treatment.info')}</HomeRightHeader>
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <Grid>
                        <Grid.Row>
                          <TitleColumn verticalAlign="middle">
                            <Header size="small">{getMessage('treatment.info.mandate')}:</Header>
                          </TitleColumn>
                          <InformationColumn verticalAlign="middle">
                            {mandate}
                          </InformationColumn>
                        </Grid.Row>
                        {
                          (selectedTreatment != undefined && selectedTreatment.diagnosis) ?
                              (
                                  <Grid.Row>
                                    <TitleColumn verticalAlign="middle">
                                      <Header size="small">{getMessage('diagnosis')}:</Header>
                                    </TitleColumn>
                                    <InformationColumn verticalAlign="middle">
                                      {selectedTreatment.diagnosis}
                                    </InformationColumn>
                                  </Grid.Row>
                              ) :
                              null
                        }
                        <Grid.Row>
                          <TitleColumn verticalAlign="middle">
                            <Header size="small">{getMessage('treatment.info.treater')}:</Header>
                          </TitleColumn>
                          <InformationColumn verticalAlign="middle">
                            {treater}
                          </InformationColumn>
                        </Grid.Row>
                        <Grid.Row>
                          <TitleColumn verticalAlign="middle">
                            <Header size="small">{getMessage('treatment.info.reason')}:</Header>
                          </TitleColumn>
                          <InformationColumn verticalAlign="middle">
                            {reason}
                          </InformationColumn>
                        </Grid.Row>
                        {
                            guarantor && guarantor.length > 0 &&
                            <Grid.Row>
                              <TitleColumn verticalAlign="middle">
                                <Header size="small">{getMessage('guarantor')}:</Header>
                              </TitleColumn>
                              <InformationColumn verticalAlign="middle">
                                {guarantor}
                              </InformationColumn>
                            </Grid.Row>
                        }
                        {
                            bookingData &&
                            <>
                              <Grid.Row>
                                <TitleColumn verticalAlign="middle">
                                  <Header size="small">{getMessage('treatment.info.location')}:</Header>
                                </TitleColumn>
                                <InformationColumn verticalAlign="middle">
                                  {bookingData.location}
                                </InformationColumn>
                              </Grid.Row>
                              <Grid.Row>
                                <TitleColumn verticalAlign="middle">
                                  <Header size="small">{getMessage('treatment.info.intervention')}:</Header>
                                </TitleColumn>
                                <InformationColumn verticalAlign="middle">
                                  {interventionDescription + " " + productCode}
                                </InformationColumn>
                              </Grid.Row>
                            </>
                        }

                        {
                          (selectedTreatment != undefined && selectedTreatment.isHospitalized)
                              ? (
                                  <Grid.Row>
                                    <TitleColumn verticalAlign="middle">
                                      <Header size="small">{getMessage('hospital')}:</Header>
                                    </TitleColumn>
                                    <InformationColumn verticalAlign="middle">
                                      {moment(selectedTreatment.hospitalizationFrom).format("DD.MM.YYYY")} - {moment(selectedTreatment.hospitalizationTo).format("DD.MM.YYYY")}
                                    </InformationColumn>
                                  </Grid.Row>
                              )
                              : null
                        }
                      </Grid>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
              <StyledColumn width={8} style={{paddingRight: 0}}>
                {
                  // Unable to work notice
                  hasUnfitSection ?
                      (
                          <>
                            <HomeRightHeader className="unable-to-work-header">
                              {getMessage('unfit.titleHeader')}
                              {hasUnfitOrPrescriptionPrivilege &&
                                  <Button className="unable-to-work-action"
                                          type="button"
                                          icon
                                          style={btnStyle}
                                          onClick={this.openUnableToWorkPdf}>
                                    <Icon name="print" size="large"/>
                                  </Button>
                              }
                            </HomeRightHeader>
                            <Grid>
                              <Grid.Row>
                                <Grid.Column width={14}>
                                  <Grid>
                                    {selectedTreatment!.unfit.map((uf) => (
                                            <Grid.Row key={uf.id}>
                                              <TitleColumn verticalAlign="middle">
                                                <Header size="small">{uf.percent} %</Header>
                                              </TitleColumn>
                                              <InformationColumn verticalAlign="middle">
                                                {moment(uf.fromDate).format("DD.MM.YYYY")} - {moment(uf.toDate).format("DD.MM.YYYY")}
                                              </InformationColumn>
                                            </Grid.Row>
                                        )
                                    )}
                                  </Grid>
                                </Grid.Column>
                                <Grid.Column width={2}>
                                  {
                                      unableToWorkPdfModalOpen &&
                                      <UnableToWorkPdfModal
                                          modalOpen={unableToWorkPdfModalOpen}
                                          onCloseModal={this.closeUnableToWorkPdfModal}
                                          pdfResponses={unableToWorkOutput}
                                          getPdfUrl={getPdfUrl}
                                          showSendEmail={currentPatient!.email}
                                          sendEmailInProgress={unableToWorkPdfSendEmailInProgress}
                                          sendEmailTextKey="unableToWorkEmailForm.send"
                                          sendEmail={this.sendUnableToWorkEmail}
                                      />
                                  }
                                </Grid.Column>
                              </Grid.Row>
                            </Grid>
                          </>
                      ) :
                      null
                }
                <>
                  <HomeRightHeader>
                    {(hasDocumentsSection || !shouldHideButtons) &&
                        getMessage('treatmentInfo.documents.title')
                    }
                    {!shouldHideButtons &&
                        <>
                          <div className="header-buttons">
                            <Popup
                                trigger={
                                  <ToolbarButton
                                      iconName="clipboard outline"
                                      iconSize="large"
                                      onClick={() => this.openPrescriptionModal()}
                                      customTrigger={(
                                          <Icon.Group size="large">
                                            <Icon name="file alternate outline"/>
                                          </Icon.Group>
                                      )}
                                      dataTooltip={getMessage("treatmentInfo.openPrescription.button")}
                                  />
                                }
                                open={false}
                            />
                            {/*<Popup
                                trigger={
                                  <ToolbarButton
                                      iconName="clipboard outline"
                                      iconSize="large"
                                      onClick={() => this.openSynopsisModal()}
                                      customTrigger={(
                                          <Icon.Group size="large">
                                            <Icon name="clipboard outline"/>
                                          </Icon.Group>
                                      )}
                                      dataTooltip={getMessage("treatmentInfo.openSynopsis.button")}
                                  />
                                }
                                open={false}
                            />*/}
                            {/*<Popup
                                trigger={
                                  <ToolbarButton
                                      iconName="heartbeat"
                                      iconSize="large"
                                      onClick={() => this.openPhysiotherapyModal()}
                                      customTrigger={(
                                          <Icon.Group size="large">
                                            <Icon name="heartbeat"/>
                                          </Icon.Group>
                                      )}
                                      dataTooltip={getMessage("treatmentInfo.openPhysiotherapy.button")}
                                  />
                                }
                                open={false}
                            />*/}
                          </div>
                        </>
                    }
                  </HomeRightHeader>
                  {hasDocumentsSection
                      ? (
                          <TreatmentDocumentsContainer>
                            <Table basic="very" compact="very" celled padded selectable>
                              <Table.Header>
                                <Table.Row>
                                  <HomeTableHeaderCell>{getMessage('type')}</HomeTableHeaderCell>
                                  <HomeTableHeaderCell>{getMessage('date')}</HomeTableHeaderCell>
                                  <HomeTableHeaderCell>{getMessage('actions')}</HomeTableHeaderCell>
                                </Table.Row>
                              </Table.Header>
                              {documents && (
                                  <Table.Body>
                                    {
                                      documents.map(document => {
                                        return (
                                            <Table.Row key={document.documentId}>
                                              <Table.Cell>
                                                {getMessage(`treatmentInfo.documents.${document.type}`)}
                                              </Table.Cell>
                                              <Table.Cell>
                                                {moment(document.date).format("DD.MM.YYYY")}
                                              </Table.Cell>
                                              <Table.Cell>
                                                {
                                                  PatientDocumentType.PATIENT_SYNOPSIS_REPORT === document.type
                                                      ? (PatientReportStatus.PREPARED === document.reportStatus
                                                          || document.reportStatus === null)
                                                          ? <EditActionButton
                                                              hoverMessage={getMessage('msgEdit')}
                                                              onConfirm={() => this.openEditDocumentModal(document)}
                                                              disabled={document.mailSent}
                                                          />
                                                          : <></>
                                                      :
                                                      <EditActionButton
                                                          hoverMessage={getMessage('msgEdit')}
                                                          onConfirm={() => {
                                                            this.openEditDocumentModal(document)
                                                          }}
                                                          disabled={document.mailSent}
                                                      />
                                                }
                                                <Button type="button"
                                                        icon
                                                        style={btnStyle}
                                                        onClick={() =>
                                                            this.openDocumentPdf(document)}
                                                >
                                                  <Icon name="print"/>
                                                </Button>
                                              </Table.Cell>
                                            </Table.Row>
                                        )
                                      })
                                    }
                                  </Table.Body>
                              )}
                            </Table>
                            {
                                prescriptionPdfModalOpen &&
                                <UnableToWorkPdfModal
                                    modalOpen={prescriptionPdfModalOpen}
                                    onCloseModal={this.closePrescriptionPdfModal}
                                    pdfResponses={prescriptionOutput}
                                    getPdfUrl={getPdfUrl}
                                    showSendEmail={currentPatient!.email}
                                    sendEmailInProgress={prescriptionPdfSendEmailInProgress}
                                    sendEmailTextKey="unableToWorkEmailForm.send"
                                    sendEmail={this.savePatientEmail}
                                />
                            }
                            {
                                synopsisReportPdfModalOpen &&
                                <PdfModal
                                    pdfResponses={synopsisReportPdfResponse}
                                    modalOpen={synopsisReportPdfModalOpen}
                                    onCloseModal={this.closeSynopsisPdfModal}
                                    getPdfUrl={this.getPatientDocumentPdfUrl}
                                    successfullyChangedReportStatus={this.successfullyChangedReportStatus}
                                    showSetControlledButton={showSetControlledButton}
                                    patientId={patientId}
                                    documentId={documentId}
                                />
                            }
                            {
                                physiotherapyReportPdfModalOpen &&
                                <PdfModal
                                    pdfResponses={physiotherapyReportPdfResponse}
                                    modalOpen={physiotherapyReportPdfModalOpen}
                                    onCloseModal={this.closePhysiotherapyPdfModal}
                                    getPdfUrl={this.getPatientDocumentPdfUrl}
                                />
                            }
                          </TreatmentDocumentsContainer>
                      )
                      : null
                  }

                  {prescriptionModalOpen && this.renderPrescriptionForm()}

                  {synopsisModalOpen && this.renderEditSynopsisReport()}

                  {physiotherapyModalOpen && this.renderEditPhysiotherapyReport()}

                </>
              </StyledColumn>
            </Grid.Row>
          </PxGrid>
        </StyledTreatmentInformation>
    );
  }

}

export default withMessages(
    withAuthContext(
        withPatientContext(
            withTreatmentsContext(
                withConsultationsContext(
                    withNotificationSystemContext(TreatmentInformation))))));
